import {
    BLENDEQUATION_ADD,
    BLENDMODE_ONE,
    BLENDMODE_ZERO,
    BlendState,
    Layer
} from 'playcanvas';

import { Element, ElementType } from './element';
import { vertexShader, fragmentShader } from './shaders/blit-shader';
import { ShaderQuad, SimpleRenderPass } from './utils/simple-render-pass';

class Underlay extends Element {
    shaderQuad: ShaderQuad;
    renderPass: SimpleRenderPass;
    enabled = true;
    private preRenderLayerHandler: ((layer: Layer, transparent: boolean) => void) | null = null;

    constructor() {
        super(ElementType.other);
    }

    add() {
        const device = this.scene.app.graphicsDevice;

        this.shaderQuad = new ShaderQuad(device, vertexShader, fragmentShader, 'apply-underlay');
        this.renderPass = new SimpleRenderPass(device, this.shaderQuad, {
            blendState: new BlendState(true,
                BLENDEQUATION_ADD, BLENDMODE_ONE, BLENDMODE_ONE,
                BLENDEQUATION_ADD, BLENDMODE_ZERO, BLENDMODE_ONE
            )
        });

        const { camera, events } = this.scene;

        this.preRenderLayerHandler = (layer: Layer, transparent: boolean) => {
            // underlay is used when outline mode is disabled
            if (!this.enabled || events.invoke('view.outlineSelection')) {
                return;
            }

            // apply at the start of the gizmo layer
            if (layer !== this.scene.gizmoLayer || transparent) {
                return;
            }

            const srcTexture = camera.workTarget?.colorBuffer;
            if (!srcTexture) {
                return;
            }

            this.renderPass.execute({ srcTexture });
        };

        camera.camera.on('preRenderLayer', this.preRenderLayerHandler);
    }

    remove() {
        const cam = this.scene?.camera?.camera;
        if (cam && this.preRenderLayerHandler) {
            cam.off('preRenderLayer', this.preRenderLayerHandler);
        }
        this.preRenderLayerHandler = null;
    }

    onPreRender() {
        // no longer need to manage a separate camera
    }
}

export { Underlay };
